var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select-ajax-user',{attrs:{"model":_vm.selectedUser,"multiple":true,"is-for-email":true,"taggable":true,"is-required":true,"name":"dev"},on:{"update:model":function($event){_vm.selectedUser=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }